import styled from 'styled-components';
import { RouterLink } from '@redux-first-router-link';

export const NavButton = styled(RouterLink)`
  display: block;
  height: auto;
  label {
    padding-right: 10px;
  }
  text-decoration: none;
  color: ${({ theme }) => theme.color.white};

  ${({ theme }) => theme.typography.small};
`;

export const MobileNavigationWrapper = styled('div')`
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: calc(${({ theme }) => theme.x7spacePx}px + env(safe-area-inset-top));
  z-index: 9000;
`;
